import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class AgeVerify {
  constructor() {
    document
      .querySelector('#age_screen #YOB')
      .addEventListener('keyup', this.validateYOB.bind(this));
    document
      .querySelector('#age_screen #ageConfirm')
      .addEventListener('click', this.onAgeConfirm.bind(this));

    // document
    //   .querySelector('#not_eligible .more_info')
    //   .addEventListener('click', function () {
    //     Global.serverObj.send(Global.URL_VUPDATE, null, null, {
    //       saveType: 'knowMoreClick',
    //       uniqID: Global.U_ID,
    //     });
    //     window.open('https://www.iard.org/', '_blank');
    //   });
  }
  init() {
    this.isValidAge = false;
    this.errorTO = null;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'AgeVerify') return false;

    document.querySelector('#age_screen').classList.add('active');
    document.querySelector('#age_screen').classList.add('active2');
    this.animateScreen();
  }
  animateScreen() {
    gsap.delayedCall(0.1, () => {
      document.querySelector('#age_screen .bg').classList.add('active');
      document
        .querySelector('#age_screen .contents .logo')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#age_screen .contents .title')
        .classList.add('active');
    });

    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#age_screen .contents .title')
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#age_screen .contents .fields .field:nth-child(1)')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#age_screen .btn_container')
        .classList.add('active');
    });
    gsap.delayedCall(0.8, () => {
      document.querySelector('#age_screen .hand').classList.add('active');
    });
  }
  onAgeConfirm() {
    if (!this.isValidAge) {
      document.querySelector('.errorSec').innerHTML = `Enter a valid Year`;
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
      return false;
    }

    document.querySelector('.errorSec').classList.remove('active');
    this.hideScreen();
    if (Global.age < 18) {
      document.querySelector('#not_eligible').classList.add('active');
      gsap.delayedCall(0.1, () => {
        document.querySelector('#not_eligible .bg').classList.add('active');
      });
      gsap.delayedCall(0.2, () => {
        document
          .querySelector('#not_eligible .contents .logo')
          .classList.add('active');
      });
      // gsap.delayedCall(0.3, () => {
      //   document
      //     .querySelector('#not_eligible .contents .title')
      //     .classList.add('active');
      // });

      gsap.delayedCall(0.4, () => {
        document.querySelector('#not_eligible').classList.add('active2');
      });
    } else {
      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'play_sound',
          data: {
            sndKey: 'music',
          },
        },
      });
      Global.yob = document.querySelector('#age_screen #YOB').value.trim();
      Global.serverObj.send(Global.URL_VUPDATE, null, null, {
        saveType: 'yobConfirmClick',
        uniqID: Global.U_ID,
      });
      Global.serverObj.send(Global.URL_DATA, null, null, {
        saveType: 'yob',
        yob: document.querySelector('#age_screen #YOB').value.trim(),
        uniqID: Global.U_ID,
      });
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'ShowAvatarSelection',
          },
        },
      });
    }
  }
  validateYOB() {
    const year = document.querySelector('#age_screen #YOB').value.trim();
    const currentYear = new Date().getFullYear();

    if (isNaN(year)) {
      this.isValidAge = false;
    } else {
      if (
        year.length == 4 &&
        parseInt(year) <= currentYear &&
        parseInt(year) >= currentYear - 150
      ) {
        Global.age = currentYear - parseInt(year);
        this.isValidAge = true;
      } else {
        this.isValidAge = false;
      }
    }
    // if (this.isValidAge) {
    //   document.querySelector('#age_screen #ageConfirm').classList.add('active');
    // } else {
    //   document
    //     .querySelector('#age_screen #ageConfirm')
    //     .classList.remove('active');
    // }
  }

  hideScreen() {
    document.querySelector('#age_screen').classList.remove('active');
    document.querySelector('#age_screen').classList.remove('active2');
  }
}
